import { __awaiter, __extends, __generator } from "tslib";
import { Lock } from "./async";
import { removeElement } from "./array";
var AbstractListenableEvent = /** @class */ (function () {
    function AbstractListenableEvent(pOwner) {
        this.mOwner = pOwner;
        this.mListeners = new Array();
        this.mLockQueue = null;
        this.mListenersLocked = false;
    }
    Object.defineProperty(AbstractListenableEvent.prototype, "hasListeners", {
        get: function () {
            return (this.mListeners.length !== 0);
        },
        enumerable: false,
        configurable: true
    });
    AbstractListenableEvent.prototype.addListener = function (pListener) {
        if (pListener == null)
            return;
        if (this.mListenersLocked)
            this.addToLockQueue(false, pListener);
        else
            this.mListeners.push(pListener);
    };
    AbstractListenableEvent.prototype.removeListener = function (pListener) {
        if (pListener == null)
            return;
        if (this.mListenersLocked)
            this.addToLockQueue(true, pListener);
        else
            removeElement(this.mListeners, pListener);
    };
    AbstractListenableEvent.prototype.addToLockQueue = function (pRemove, pListener) {
        if (this.mLockQueue == null)
            this.mLockQueue = new Array();
        this.mLockQueue.push({ remove: pRemove, listener: pListener });
    };
    AbstractListenableEvent.prototype.processLockQueue = function () {
        if (this.mLockQueue == null)
            return;
        for (var _i = 0, _a = this.mLockQueue; _i < _a.length; _i++) {
            var tEntry = _a[_i];
            if (tEntry.remove)
                this.removeListener(tEntry.listener);
            else
                this.addListener(tEntry.listener);
        }
        this.mLockQueue = null;
    };
    return AbstractListenableEvent;
}());
export { AbstractListenableEvent };
/**
* Synchronous listenable event.
*/
var ListenableEvent = /** @class */ (function (_super) {
    __extends(ListenableEvent, _super);
    function ListenableEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListenableEvent.prototype.trigger = function (pParameter) {
        if (this.mListeners.length === 0)
            return;
        this.mListenersLocked = true; //lock listeners array
        try {
            for (var _i = 0, _a = this.mListeners; _i < _a.length; _i++) {
                var tListener = _a[_i];
                tListener(pParameter, this.mOwner);
            }
        }
        finally {
            this.mListenersLocked = false;
            this.processLockQueue();
        }
    };
    return ListenableEvent;
}(AbstractListenableEvent));
export { ListenableEvent };
/**
* Asynchronous listenable event.
*/
var AsyncListenableEvent = /** @class */ (function (_super) {
    __extends(AsyncListenableEvent, _super);
    function AsyncListenableEvent(pOwner) {
        var _this = _super.call(this, pOwner) || this;
        _this.mTriggerLock = new Lock();
        return _this;
    }
    AsyncListenableEvent.prototype.trigger = function (pParameter) {
        return __awaiter(this, void 0, void 0, function () {
            var tLockContext, _i, _a, tListener;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.mListeners.length === 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.mTriggerLock.acquireLock()];
                    case 1:
                        tLockContext = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, , 7, 8]);
                        this.mListenersLocked = true; //lock listeners array
                        _i = 0, _a = this.mListeners;
                        _b.label = 3;
                    case 3:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        tListener = _a[_i];
                        return [4 /*yield*/, tListener(pParameter, this.mOwner)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.mListenersLocked = false;
                        this.processLockQueue();
                        tLockContext.unlock();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return AsyncListenableEvent;
}(AbstractListenableEvent));
export { AsyncListenableEvent };
